export const actionHistoryTableCellWidth = {
    TIME: 367,
    USER_NAME:366,
    ACTION_TYPE:365,
    ENTITY_TITLE:360,
    CHANGES:350,
  }